// src/app/shared/pipes/custom-currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '@aex/shared/root-services';

@Pipe({
	name: 'customCurrency',
})
export class CustomCurrencyPipe implements PipeTransform {

	constructor(private readonly configService: ConfigService) {
	}

	transform(value: number | null | undefined): string {
		const currency = this.configService.configValues.currency ?? 'R';

		if (value === null || value === undefined)
			return `${currency} 0.00`;

		return `${currency} ${value.toFixed(2)}`;
	}
}
